import { User } from 'lucide-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar.jsx';
import { cn } from '@/lib/utils.js';

function orgInitials(value) {
  return (value ?? '?').slice(0, 2).toUpperCase();
}

export function teamAvatarUrl(team) {
  const org = team?.github_org;
  return org ? `https://github.com/${org}.png?size=64` : null;
}

/**
 * Round avatar for a team. Uses the GitHub org logo when team.github_org
 * is set (https://github.com/{org}.png?size=64 redirects to the cached
 * avatar with no auth required); falls back to org initials. Personal
 * teams (no github_org) render a generic person icon.
 */
export function TeamAvatar({ team, size = 'sm', className }) {
  const org = team?.github_org;

  if (!org) {
    return (
      <span
        data-slot="team-avatar-personal"
        data-testid="team-avatar-personal"
        className={cn(
          'inline-flex shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground',
          size === 'sm' ? 'size-6' : 'size-8',
          className,
        )}
        aria-hidden="true"
      >
        <User className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} />
      </span>
    );
  }

  return (
    <Avatar size={size} className={className}>
      <AvatarImage src={`https://github.com/${org}.png?size=64`} alt={org} />
      <AvatarFallback>{orgInitials(org)}</AvatarFallback>
    </Avatar>
  );
}
